import { useCallback, useEffect } from "react";

import { useModuleDispatch } from "2g-redux-module-provider";
import { useValues } from "2g-form/hooks";
import { actions } from "2g-form";
import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";

import { DATA } from "b2b/api/paths";
import { REZERVACE as PATH_REZERVACE } from "b2b/constants/paths";
import { useRedirect } from "b2b/hooks";

import createRezervaceVytvoreniRequest from "../utils/createRezervaceVytvoreniRequest";
import useMessages from "../i18n/useMessages";

export default function useRezervaceVytvoreniForm({ moduleKey } = {}) {
  const { saveDialogTitle } = useMessages();
  const values = useValues(moduleKey) || {};
  const dispatchFormAction = useModuleDispatch(moduleKey);
  const { showDialog, hideDialog } = useDialogsProvider();
  const redirect = useRedirect();

  const redirectToRezervaceHistorie = useCallback(() => {
    redirect(PATH_REZERVACE.HISTORIE);
  }, [redirect]);

  const handleSuccess = useCallback(() => {
    hideDialog();
    redirectToRezervaceHistorie();
  }, [hideDialog, redirectToRezervaceHistorie]);

  const handleSubmit = useCallback(
    ({ values, submitter }) => {
      showDialog(ZpracDialog, {
        url: DATA.zadostiCreate(),
        payload: createRezervaceVytvoreniRequest(values),
        title: saveDialogTitle(),
        onClose: hideDialog,
        onSuccess: handleSuccess
      });
    },
    [handleSuccess]
  );

  useEffect(
    () => () => {
      dispatchFormAction(
        actions.setValues({
          zakaznik: values.zakaznik,
          uzivatel: values.uzivatel
        })
      );
    },
    []
  );

  return {
    onSubmit: handleSubmit,
    disabledSubmit: !(
      values.zakaznik &&
      values.uzivatel &&
      values.projekt &&
      values.produkt &&
      values.datumOd &&
      values.datumDo
    )
  };
}
